export default __webpack_public_path__ + "static/media/cdp-logo-coloured.cf97eb7f.svg";